export default "__VITE_ASSET__NgkaOKxs__";